<script setup lang="ts">
  import { useLegacyAppStore } from '@/store/legacy-app.store'
  import { Modal, UiButton } from '@logistiek-zonder-papier/lzp-library'

  const appStore = useLegacyAppStore()

  function reload() {
    window.location.reload()
  }
</script>

<template>
  <Modal class="error-modal" v-model:show="appStore.showErrorModal" size="large">
    <template #header><div class="error-header">Er is iets fout gegaan!</div></template>
    <template #default>
      <div class="error-body">
        Er is iets fout gegaan. Wilt u doorgaan of de pagina opnieuw laden.
        <br />
        <br />
        Als u de pagina opnieuw laad kunt uw huidige werk verloren gaan.
      </div>
    </template>
    <template #footer="{ close }">
      <div class="error-footer">
        <UiButton class="error-footer-button" label="Sluiten" size="large" @click="close" />
        <UiButton
          class="error-footer-button"
          label="Pagina herladen"
          size="large"
          @click="reload"
        />
      </div>
    </template>
  </Modal>
  <div class="wrapper">
    <RouterView />
  </div>
</template>

<style scoped>
  .error-header {
    font-size: 4rem;
    text-align: center;
    width: 100%;
    padding-top: var(--spacing-s);
  }

  .error-modal {
    z-index: 99999999;
  }

  .error-body {
    height: 50vh;
    font-size: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  .error-footer {
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
  }

  .error-footer-button :deep(.text) {
    font-size: 1.5rem;
  }
</style>
